import React from "react";

const currentYear = new Date().getFullYear();

function Footer() {
  return (
    <footer className="footer mt-auto  p-4 text-slate-400 bg-transparent">
      <div className="items-center grid-flow-col">
        <p>Copyright © eHawk Solutions {currentYear}</p>
      </div>
    </footer>
  );
}

export default Footer;
